var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "fixed z-50 pin overflow-auto bg-modal",
      class: _vm.active ? "block" : "hidden"
    },
    [
      _c(
        "div",
        {
          staticClass:
            "bg-grey-dark relative rounded shadow max-w-sm h-auto mx-auto mt-24"
        },
        [
          _c("div", { staticClass: "p-6" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "text-center text-white" }, [
              _vm._v(_vm._s(_vm.$t("Signing_out")))
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center mb-4" }, [
      _c("img", {
        staticClass: "h-48",
        attrs: { src: "/static/img/login_img.png", alt: "Tooddoc Logo" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ca88c99", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ca88c99","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Patient/LogoutModal.vue
// module id = 579
// module chunks = 1